import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducers, effects } from './_store';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('dashboard', reducers), EffectsModule.forFeature(effects)]
})
export class DataAccessStoreModule {}
